module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAC/SURBVCiRldGxDcIwEIXh/zJRMgQ1BUMkEokcBGwRRCxS4CHoYA7SsQ1HQ4NzVoJL675n3534IbwQvbttdWTh8Zdrj8g6U3igcuiHcP4DOoWbRBd9W5e7OYiqd03VipFoBsQQQKyCOMCCE2wFpKCJo4BRILdgEgP4ITyBHBhdXRZWTZZ8+QuBPLXGCf7psS4LVL1AawWY0457TG1hsufUcKwAWQJTAdIPoRPYz8HJD0W7TGCzFAK4pmoVTrxl9QFAL6HF0NqmkQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/guanbi.png
// module id = hPLp
// module chunks = 1